import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Explicit import
window.bootstrap = bootstrap; // ✅ Assign bootstrap to window so it's accessible globally

export function BootstrapTooltips() {
  const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));

  tooltipTriggerList.forEach(el => {
    // ✅ Just call the method, no unused variable
    bootstrap.Tooltip.getOrCreateInstance(el);

    el.addEventListener('click', () => {
      const instance = bootstrap.Tooltip.getInstance(el);
      if (instance) {
        setTimeout(() => instance.hide(), 200);
      }
    });

    el.addEventListener('mouseleave', () => {
      const instance = bootstrap.Tooltip.getInstance(el);
      if (instance) {
        instance.hide();
      }
    });
  });
}

export function DisposeAllTooltips() {
  const tooltipList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipList.forEach(el => {
    const tooltipInstance = bootstrap.Tooltip.getInstance(el);
    if (tooltipInstance) {
      tooltipInstance.dispose(); // 🧹 Hide and destroy
    }
  });
}